import isEmail from 'validator/lib/isEmail';

export const stringToArray = str => {
  if (!str) return [];
  if (Array.isArray(str)) return str;

  let cleanStr = str;
  if (cleanStr.trim().startsWith('[') && cleanStr.trim().endsWith(']')) {
    cleanStr = cleanStr.replace(/[\[\]"']/g, '');
  }

  return cleanStr
    .split(',')
    .map(e => e.trim())
    .filter(Boolean);
};

export const arrayToString = arr => {
  if (!Array.isArray(arr)) return '';
  return arr
    .map(e => e.trim())
    .filter(Boolean)
    .join(', ');
};

export const mergeRecipients = (receiptEmails, exportEmails) => {
  const receipts = stringToArray(receiptEmails);
  const exports = stringToArray(exportEmails);

  const emailMap = new Map();

  receipts.forEach(email => {
    emailMap.set(email, {
      email,
      receiveReceipts: true,
      receiveExports: false,
    });
  });

  exports.forEach(email => {
    if (emailMap.has(email)) {
      emailMap.get(email).receiveExports = true;
    } else {
      emailMap.set(email, {
        email,
        receiveReceipts: false,
        receiveExports: true,
      });
    }
  });

  return Array.from(emailMap.values());
};

export const splitRecipientsForBackend = recipients => {
  const receiptEmails = [];
  const financeEmails = [];

  (recipients || []).forEach(r => {
    if (r.receiveReceipts) receiptEmails.push(r.email);
    if (r.receiveExports) financeEmails.push(r.email);
  });

  return {
    receiptEmails,
    financeEmail: arrayToString(financeEmails),
  };
};

export const isRecipientValid = recipient => {
  const hasEmail = isEmail(recipient.email);
  const hasSelection = recipient.receiveReceipts || recipient.receiveExports;
  return hasEmail && hasSelection;
};

export const hasIncompleteRecipients = recipients => {
  if (!recipients || recipients.length === 0) return false;
  return recipients.some(r => !isRecipientValid(r));
};
